import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { FilterChip } from "../../FilterChip";

export function StepEventType({ eventTypes, answers, setAnswers }) {
  function select(key) {
    setAnswers((prev) => ({ ...prev, event_type: key }));
  }

  return (
    <Box>
      <Text fontSize={{ base: "17px", md: "20px" }} fontWeight="900" color="#004a33" mb="3px">
        Que tipo de evento é?
      </Text>
      <Text fontSize="12px" color="gray.500" mb="12px">
        Isso ajuda a Boozen a ajustar a proporção certa de cada bebida.
      </Text>

      <SimpleGrid columns={{ base: 2, sm: 3, md: 4 }} spacing="6px">
        {eventTypes.map((e) => (
          <FilterChip
            key={e.key}
            label={e.label}
            isActive={answers.event_type === e.key}
            onClick={() => select(e.key)}
          />
        ))}
      </SimpleGrid>
    </Box>
  );
}
